/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import {Platform} from 'react-native';
import {
  assuredAgeIsDifferentFromDevis,
  countPersonsInAgeRanges,
  findOldestDate,
  generateUUID,
  replaceSpecialCharacters,
} from '../../common/utils/functions';

import dayjs from 'dayjs';
import 'dayjs/locale/fr';
import {
  dataConfig,
  defaultAssured,
  initModalData,
  listAssured,
  listRenseignement,
  modalDatasModified,
  showErrorAssuredDefault,
  showErrorAssuredSubmit,
  showErrorValuesDefault,
  showErrorValuesSubmit,
} from '../../data/constants/Assurance/AssuranceVoyage/souscription';
import {
  IError,
  IValues,
  ModalDataDTO,
} from '../../data/types/interface/Assurance/AssuranceVoyage/souscription';

export const useFormSouscription = (
  data: IValues,
  setData: (value: any) => void,
  initData: IValues,
  Validate: any,
  onCancel: any,
  handleSave: any,
  listAgence?: any,
  user?: any,
) => {
  const [showErrors, setShowErrors] = React.useState({
    ...showErrorValuesDefault,
  });
  const errors = React.useMemo(() => Validate(data, listAgence), [data]);

  const [modalData, setModalData] = React.useState<ModalDataDTO>({
    ...initModalData,
  });

  const handleChange = (name: keyof IValues, value: any, fired: boolean) => {
    setShowErrors({...showErrors, [name]: value !== fired});
    if (name !== 'userIsAssured') {
      setData({...data, [name]: value});
    } else {
      setData(
        (prevValues: IValues) =>
          ({
            ...prevValues,
            [name]: value,
            assure: [
              ...prevValues.assure.map((currentAssured: any, index: number) =>
                index === 0
                  ? {
                      ...currentAssured,
                      nom: replaceSpecialCharacters(user.nom)
                        .replace(/[^A-Za-z0-9 ]/g, ' ')
                        .toUpperCase(),
                      prenom: replaceSpecialCharacters(user.prenom)
                        .replace(/[^A-Za-z0-9 ]/g, ' ')
                        .toUpperCase(),
                      dateNaissance: dayjs(
                        user.dateNaissance,
                        'DD/MM/YYYY',
                      ).toDate(),
                      email: user.email,
                      telephone: user.telephone,
                      countryCode: user.countryCode,
                    }
                  : {...currentAssured},
              ),
            ],
          } as any),
      );
    }
  };

  const noError = (errors: IError) => {
    let bNoError = true;
    Object.entries(errors).forEach(element => {
      const errorsException: Array<string> = ['assure', 'userIsAssured'];
      if (element[1] !== '' && !errorsException.includes(element[0])) {
        bNoError = false;
      } else if (element[0] === 'assure' && element[1].length) {
        element[1].map((assureElt: any) => {
          const assureEltException: Array<string> = ['id'];
          Object.entries(assureElt).forEach(assureEltProperty => {
            if (
              assureEltProperty[1] !== '' &&
              !assureEltException.includes(assureEltProperty[0])
            ) {
              bNoError = false;
            }
          });
        });
      }
    });
    return bNoError;
  };

  const listMenuNotOk = (errors: any) => {
    errors.assure?.length &&
      errors.assure.map((assureElt: any) => {
        let assureEltStatus: 'sante' | 'renseignement' | undefined = undefined;
        Object.entries(assureElt).map((assureEltProperty: any) => {
          if (
            assureEltProperty[1] &&
            assureEltStatus !== 'renseignement' &&
            listRenseignement.includes(assureEltProperty[0])
          ) {
            assureEltStatus = 'renseignement';
          }
        });
        assureEltStatus &&
          listAssured.push({id: assureElt.id, menu: assureEltStatus});
      });

    return listAssured;
  };

  const handleSubmit = () => {
    setShowErrors({
      ...showErrorValuesSubmit,
      assure: data.assure.length
        ? [
            ...data.assure.map((element: any) => ({
              ...showErrorAssuredSubmit,
              id: element.id,
            })),
          ]
        : [],
    });

    if (noError(errors)) {
      const nbrAges = countPersonsInAgeRanges(
        data.assure,
        {
          childrens: {
            min: dataConfig.ageGap.enfant.min,
            max: dataConfig.ageGap.enfant.max,
          },
          adults: {
            min: dataConfig.ageGap.adult.min,
            max: dataConfig.ageGap.adult.max,
          },
          seniors: {
            min: dataConfig.ageGap.senior.min,
            max: dataConfig.ageGap.senior.max,
          },
        },
        'dateNaissance',
      );
      const oldAges = countPersonsInAgeRanges(
        initData.assure,
        {
          childrens: {
            min: dataConfig.ageGap.enfant.min,
            max: dataConfig.ageGap.enfant.max,
          },
          adults: {
            min: dataConfig.ageGap.adult.min,
            max: dataConfig.ageGap.adult.max,
          },
          seniors: {
            min: dataConfig.ageGap.senior.min,
            max: dataConfig.ageGap.senior.max,
          },
        },
        'dateNaissance',
      );
      const currentOldest = findOldestDate(
        data.assure,
        'dateNaissance',
      ).toString();
      const devisOldest = findOldestDate(
        initData.assure,
        'dateNaissance',
      )?.toString();

      // If Devis is different to Souscription then show Modal
      if (assuredAgeIsDifferentFromDevis(nbrAges, oldAges)) {
        setModalData({
          status: true,
          title: 'Information',
          content: `Il y a une incohérence entre les informations du devis et celles de la souscription:\n\nDEVIS => SOUSCRIPTION\n${
            nbrAges?.childrens !== oldAges.childrens
              ? `enfant: ${nbrAges?.childrens} => enfant: ${oldAges.childrens}`
              : ''
          }\n${
            nbrAges?.adults !== oldAges.adults
              ? `adulte: ${nbrAges?.adults} => adulte: ${oldAges.adults}`
              : ''
          }\n${
            nbrAges?.seniors !== oldAges.seniors
              ? `senior: ${nbrAges?.seniors} => senior: ${oldAges.seniors}`
              : ''
          }`,
          btn1: 'Poursuivre',
          btn2: 'Rectifier Souscription',
          handleBtn1: () => {
            handleSave(data);
          },
          handleBtn2: () => setModalData({...initModalData}),
        });
      } else if (currentOldest !== devisOldest) {
        setModalData({
          status: true,
          title: 'Information',
          content: `Il y a une incohérence entre les informations du devis et celles de la souscription concernant la date du plus âgé`,
          btn1: 'Poursuivre',
          btn2: 'Rectifier Souscription',
          handleBtn1: () => {
            handleSave(data);
          },
          handleBtn2: () => setModalData({...initModalData}),
        });
      } else {
        handleSave(data);
      }
    } else {
      console.log(errors);

      const listMenuToOpen = listMenuNotOk(errors);
      setData((prevValues: any) => ({
        ...prevValues,
        assure: [
          ...prevValues.assure.map((assureElt: any) => ({
            ...assureElt,
            menu: listMenuToOpen.some(
              menuToOpen => assureElt.id === menuToOpen.id,
            )
              ? listMenuToOpen.find(
                  menuToOpen => menuToOpen.id === assureElt.id,
                )?.menu
              : assureElt.menu,
          })),
        ],
      }));
    }
  };

  const handleAddAssured = (
    nbrAssured?: number,
    accept: boolean = false,
    init: boolean = false,
  ) => {
    const nbr: number = nbrAssured || 1;

    if (!accept) {
      setModalData({
        status: true,
        title: modalDatasModified.title,
        content: modalDatasModified.content,
        btn1: modalDatasModified.btn1,
        btn2: modalDatasModified.btn2,
        handleBtn1: () => {
          handleAddAssured(1, true);
          setModalData({...initModalData});
        },
        handleBtn2: () => setModalData({...initModalData}),
      });
    } else {
      const currentIDs: string[] = Array.from({length: nbr}, generateUUID);

      const updateAssuredArray = (prevAssured: any[], defaultAssured: any) =>
        prevAssured.concat(currentIDs.map(id => ({...defaultAssured, id})));

      setData((prevDatas: any) => ({
        ...prevDatas,
        assure: init
          ? updateAssuredArray([], defaultAssured)
          : updateAssuredArray(prevDatas.assure, defaultAssured),
      }));

      setShowErrors((prevShow: any) => ({
        ...prevShow,
        assure: init
          ? updateAssuredArray([], showErrorAssuredDefault)
          : updateAssuredArray(prevShow.assure, showErrorAssuredDefault),
      }));
    }
  };

  const handleInitValues = () => {
    setData({...data});
  };

  const handleRemoveAssured = (id: string, accept: boolean = false) => {
    if (!accept) {
      setModalData({
        status: true,
        title: modalDatasModified.title,
        content: modalDatasModified.content,
        btn1: modalDatasModified.btn1,
        btn2: modalDatasModified.btn2,
        handleBtn1: () => {
          handleRemoveAssured(id, true);
          setModalData({...initModalData});
        },
        handleBtn2: () => setModalData({...initModalData}),
      });
    } else {
      setData((prevDatas: any) => ({
        ...prevDatas,
        assure: [
          ...prevDatas.assure.filter((element: any) => element.id !== id),
        ],
      }));
      setShowErrors((prevShow: any) => ({
        ...prevShow,
        assure: [
          ...prevShow.assure.filter((element: any) => element.id !== id),
        ],
      }));
    }
  };

  const handleChangeAssured = (
    id: string,
    name: string,
    value: any,
    fired: boolean,
    remove?: boolean,
  ) => {
    setShowErrors((prevErrors: any) => ({
      ...prevErrors,
      assure: [
        ...prevErrors.assure.map((element: any) => {
          if (element.id !== id) {
            return element;
          } else {
            return {
              ...element,
              [name]: value !== fired,
            };
          }
        }),
      ],
    }));

    const listToUpperCase: Array<string> = ['nom', 'prenom'];

    setData((prevValues: IValues) => {
      return {
        ...prevValues,
        assure: [
          ...prevValues.assure.map((assureElt: any) => {
            if (assureElt.id !== id) {
              return assureElt;
            } else {
              if (name === 'menu') {
                return {
                  ...assureElt,
                  [name]: value,
                  allMenu: true,
                };
              } else if (name === 'passport_file') {
                const _value =
                  Platform.OS !== 'web'
                    ? {
                        uri: value?.uri,
                        type: value?.type,
                        name: value?.fileName,
                      }
                    : value;

                if (remove) {
                  return {
                    ...assureElt,
                    [name]: [],
                  };
                }

                const images: Array<any> = assureElt[name]
                  ? [...assureElt[name]]
                  : [];
                images.push(_value);

                return {
                  ...assureElt,
                  [name]: images,
                };
              } else if (listToUpperCase.includes(name)) {
                return {
                  ...assureElt,
                  [name]:
                    typeof value === 'string'
                      ? replaceSpecialCharacters(value)?.replace(
                          /[^A-Za-z0-9 ]/g,
                          '',
                        )
                      : value,
                };
              } else {
                return {
                  ...assureElt,
                  [name]:
                    typeof value === 'string'
                      ? replaceSpecialCharacters(value)
                      : value,
                };
              }
            }
          }),
        ],
      };
    });
  };

  const handleCancel = () => {
    setData(initData);
    onCancel();
  };

  return {
    handleChange,
    handleSubmit,
    isDisable: !!data.assure.length,
    handleCancel,
    values: data,
    errors: errors,
    showErrors,
    handleAddAssured,
    handleRemoveAssured,
    handleChangeAssured,
    handleInitValues,
    modalData,
  };
};
